'use client';

import {
  Button,
  FormControl,
  FormLabel,
  Stack,
  TextField,
} from '@mui/material';

import { StepContainer } from '@/components/wizard/StepContainer';
import type { StepProps } from '@/components/wizard/StepProps';

import type { IngestionPipelineWizardState } from '../IngestionPipelineWizardState';

export function PipelineDetailsStep(
  props: StepProps<IngestionPipelineWizardState>
) {
  const { name, namespace, tableName } = props.wizardState;

  const canGoNext = () => {
    return (
      name.trim() !== '' && namespace.trim() !== '' && tableName.trim() !== ''
    );
  };

  const handleNext = async () => {
    props.setNextStep(props.currentStep.next?.[0]);
  };

  return (
    <StepContainer
      stepperIndex={0}
      stepperLabels={props.stepperLabels}
      canGoNext={canGoNext}
      onNextClick={handleNext}
      onBackClick={props.back}
    >
      <Stack sx={{ height: '100%', paddingTop: '5%' }} alignItems='center'>
        <Stack width='400px' gap='24px'>
          <FormControl fullWidth>
            <FormLabel>Pipeline Name</FormLabel>
            <TextField
              size='small'
              placeholder='Enter pipeline name'
              value={name}
              onChange={(e) =>
                props.setWizardState((s) => ({ ...s, name: e.target.value }))
              }
              data-testid='pipeline-name-input'
            />
          </FormControl>

          <FormControl fullWidth>
            <FormLabel>Table Namespace</FormLabel>
            <TextField
              size='small'
              placeholder='e.g. analytics'
              value={namespace}
              onChange={(e) =>
                props.setWizardState((s) => ({
                  ...s,
                  namespace: e.target.value,
                }))
              }
              data-testid='pipeline-namespace-input'
            />
          </FormControl>

          <FormControl fullWidth>
            <FormLabel>Table Name</FormLabel>
            <TextField
              size='small'
              placeholder='e.g. clickstream_events'
              value={tableName}
              onChange={(e) =>
                props.setWizardState((s) => ({
                  ...s,
                  tableName: e.target.value,
                }))
              }
              data-testid='pipeline-table-name-input'
            />
          </FormControl>

          <Button
            variant='contained'
            disabled={!canGoNext()}
            onClick={() => void handleNext()}
            sx={{ height: '48px' }}
            data-testid='pipeline-details-continue-btn'
          >
            Continue
            <i className='material-symbols-arrow-right-alt ml-[8px]' />
          </Button>
        </Stack>
      </Stack>
    </StepContainer>
  );
}
